import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api';
import { useAuth } from '../../context/AuthContext';
import { Alert, Spinner, EmptyState } from '../../components/UI';

function formatRemaining(sec) {
  if (sec == null) return '--';
  if (sec <= 0) return 'Time is over';
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return m > 0 ? `${m} min ${s} sec` : `${s} sec`;
}

export default function UserHome() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [starting, setStarting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      setData(await api.get('/exam/active'));
    } catch (e) { setError(e.message); }
  }

  async function handleStart() {
    setStarting(true);
    setError('');
    try {
      const res = await api.post('/exam/start', {});
      navigate(`/exam/${res.attempt_id}`);
    } catch (e) {
      setError(e.message);
      setStarting(false);
    }
  }

  if (!data && !error) return <Spinner />;

  const { paper, attempt } = data || {};

  return (
    <div className="content-narrow">
      <div className="page-header">
        <div>
          <div className="eyebrow">Welcome</div>
          <h1>Hi, {user?.name?.split(' ')[0]}</h1>
        </div>
      </div>

      <Alert type="danger">{error}</Alert>

      {!paper && (
        <div className="card">
          <EmptyState
            title="No exam is live for you right now"
            sub="No exam has been started and assigned to you yet. Check back once it's announced."
          />
        </div>
      )}

      {paper && attempt?.status === 'in_progress' && (
        <div className="card">
          <h3>{paper.title}</h3>
          <p>
            You have an exam in progress. Resume where you left off - your answers are saved.
            The clock has been running the whole time.
          </p>
          <p>
            Time remaining: <strong>{formatRemaining(attempt.seconds_left)}</strong>
          </p>
          <button className="btn btn-primary" onClick={() => navigate(`/exam/${attempt.id}`)}>
            {attempt.seconds_left > 0 ? 'Resume exam' : 'Submit exam'}
          </button>
        </div>
      )}

      {paper && attempt && attempt.status !== 'in_progress' && (
        <div className="card">
          <h3>{paper.title}</h3>
          <p>You've already submitted this exam. Your result will appear under My Results once it's published.</p>
        </div>
      )}

      {paper && !attempt && (
        <div className="card">
          <h3>{paper.title}</h3>
          {paper.description && <p>{paper.description}</p>}
          <p>Duration: <strong>{paper.duration_minutes} minutes</strong>. Once you start, the timer cannot be paused.</p>
          <button className="btn btn-primary" onClick={handleStart} disabled={starting}>
            {starting ? 'Starting…' : 'Start exam'}
          </button>
        </div>
      )}
    </div>
  );
}
